export default () => {
  const windowHeight: number =
    window.innerHeight || document.documentElement.clientHeight;

  const lazyLoadBg = () => {
    const bgImages = [...document.querySelectorAll('.lazyload-bg')];

    bgImages.forEach(function (el: Element, i) {
      const { top, height } = el.getBoundingClientRect();

      if (
        (top > 0 && top < windowHeight) ||
        top < windowHeight + height ||
        (top > windowHeight + height && top < windowHeight + 2 * height)
      ) {
        const style = el.getAttribute('style');
        let styleString = '';

        const { lazyBg, lazyBgxl, lazyBg4k } = (el as HTMLElement).dataset;

        if (lazyBg !== undefined) {
          styleString += `--lazy-bg:url(${lazyBg});`;
          el.removeAttribute(`data-lazy-bg`);
        }

        if (lazyBgxl !== undefined) {
          styleString += `--lazy-bg-xl:url(${lazyBgxl});`;
          el.removeAttribute(`data-lazy-bgxl`);
        }

        if (lazyBg4k !== undefined) {
          styleString += `--lazy-bg-4k:url(${lazyBg4k});`;
          el.removeAttribute(`data-lazy-bg4k`);
        }

        style === null
          ? el.setAttribute('style', styleString)
          : el.setAttribute('style', `${style} ${styleString}`);

        el.classList.replace('lazyload-bg', 'lazyloaded-bg');
      }
    });

    if (bgImages.length == 0) window.removeEventListener('scroll', lazyLoadBg);
  };

  window.addEventListener('scroll', lazyLoadBg);
};
